<fullscreen-page>
  <content-column look="dark">
    <div slot="content" class="h-100 p-2">
      <div class="d-flex flex-row h-100 w-100">
        <div class="d-flex flex-column h-100 w-50 me-1" style="background-color: var(--dx-color-main-bg);">
          <div class="d-flex flex-row justify-content-evenly" style="min-height: 50px">
            <div class="d-flex flex-row align-items-center justify-content-center">
              <div class="mx-1">
                {{ 'Übertragen von' | translate }}
              </div>
              <np-license-upgrade-button *ngIf="isOnboarding" class="mx-1"/>
              <div>
                <dx-check-box class="mx-1"
                              [readOnly]="isOnboarding"
                              [(value)]="transferCategories"
                              text="{{ 'Kategorien' | translate }}"/>
                <dx-check-box class="mx-1"
                              [readOnly]="isOnboarding"
                              [(value)]="transferProducts"
                              text="{{ 'Produkte' | translate }}"/>
              </div>
            </div>
            <div class="d-flex flex-row align-items-center justify-content-center">
              <div class="mx-1">
                {{ 'Modus' | translate }}
              </div>
              <div *ngIf="!isTargetCatalogVirtual" class="mx-1">
                <dx-radio-group [items]="operationsNonVirtual"
                                [(value)]="selectedOperation"
                                layout="horizontal"
                                [disabled]="operationsDisabled"/>
              </div>
              <div *ngIf="isTargetCatalogVirtual" class="mx-1">
                <dx-radio-group [items]="operationsVirtual"
                                [(value)]="selectedOperation"
                                layout="horizontal"
                                [disabled]="operationsDisabled"/>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column h-100 w-100">
            <div class="dx-fieldset">
              <div class="dx-field">
                <div class="dx-field-label">
                  {{ 'Account' | translate }}
                </div>
                <div class="dx-field-value d-flex flex-row">
                  <dx-select-box class="w-100"
                                 [value]="modelService?.loginService?.currentUser?.customerId"
                                 [dataSource]="customers"
                                 displayExpr="name"
                                 valueExpr="id"
                                 [searchEnabled]="true"
                                 [readOnly]="true"/>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label">
                  {{ 'Quellkatalog' | translate }}
                </div>
                <div class="dx-field-value d-flex flex-row">
                  <dx-select-box class="w-100"
                                 [items]="sourceCatalogs"
                                 valueExpr="id"
                                 [value]="selectedSourceCatalogId"
                                 displayExpr="catalogName"
                                 [searchEnabled]="true"
                                 (onSelectionChanged)="sourceSelected($event)"
                                 noDataText="{{ 'keine Kataloge im Account' | translate }}"></dx-select-box>
                </div>
              </div>
            </div>

            <np-catalog-tree #catalogTreeSource
                [catalogId]="selectedSourceCatalogId"
                [customerId]="modelService.loginService.currentUser?.customerId"
                [catalogList]="sourceCatalogs"
                [(searchText)]="filterValue"
                selectionMode="multiple"
                [selectionRecursive]="false"
                [selectionAllowSelectAll]="false"
                [(selectedRowKeys)]="treeSelectedRowKeysSource"
                [showProductStateOptions]="true"
                [showSearchFormTab]="loginService.hasAddonSearchForm"
                [refreshWithSearchForm]="refreshWithSearchForm"
                [syncSearchFormWithService]="false"
                [hasSpidFn]="hasSpid"
                [dragGroup]="'catalogs'"
                [onDragStartFn]="onDragStartSource"
                (onRowClick)="onRowClick($event)"
                (onEditSearchForm)="toggleSearchFormPopup($event)">
            </np-catalog-tree>
          </div>
        </div>

          <div class="d-flex flex-column h-100 w-50 ms-1" style="background-color: var(--np-secondary-color);">

              <div class="d-flex flex-row align-items-center justify-content-center">
                  <div class="mx-1">
                      {{ 'Bei Konflikten' | translate }}
                  </div>
                  <div>

            
                      <dx-radio-group class="mx-1" (onValueChanged)="changeMergeStrategy($event)"
                                      [(value)]="modelMergestrategy"
                                      displayExpr="text"
                                      [dataSource]="modelMergestrategyItems"
                                      valueExpr="mergeType"                     
                      ></dx-radio-group>
                    
                  </div>
              </div>

              <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">
                {{ 'Account' | translate }}
              </div>
              <div class="dx-field-value d-flex flex-row">
                <dx-select-box class="w-100"
                               [readOnly]="isOnboarding"
                               [(value)]="selectedCustomerId"
                               [dataSource]="customers"
                               displayExpr="name"
                               valueExpr="id"
                               [searchEnabled]="true"/>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ 'Zielkatalog' | translate }}
              </div>
              <div class="dx-field-value d-flex flex-row">
                <dx-select-box class="w-100"
                               [items]="targetCatalogs"
                               valueExpr="id"
                               [value]="selectedTargetCatalogId"
                               displayExpr="catalogName"
                               [searchEnabled]="true"
                               (onSelectionChanged)="targetSelected($event)"
                               noDataText="{{ 'keine Kataloge im Account' | translate }}"
                               fieldTemplate="field"
                               itemTemplate="item">
                  <div *dxTemplate="let data of 'field'">
                    <dx-text-box [ngClass]="{ virtualCatalogColor: data?.isVirtual }"
                                 [value]="data?.catalogName"></dx-text-box>
                  </div>

                  <div *dxTemplate="let data of 'item'" [ngClass]="{ virtualCatalogColor: data.isVirtual }">
                    {{ data.catalogName }}
                  </div>
                </dx-select-box>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row w-100 justify-content-between">

            <div class="px-6 pt-6" style="padding: 6px">
              <dx-tree-list id="treeListBrain"
                            *ngIf="showAiDropZone()"
                            class="tree dropZone"
                            style="height: 100%"
                            [dataSource]="brainData"
                            keyExpr="id"
                            parentIdExpr="parentId"
                            rootValue="0"
                            [showBorders]="false"
                            [showColumnHeaders]="false"
                            [showColumnLines]="false">

                <dxo-row-dragging [onAdd]="onClassifAi"
                                  [onDragStart]="onDragStartTarget"
                                  group="catalogs"
                                  [allowDropInsideItem]="true"
                                  [allowReordering]="false"
                                  [showDragIcons]="false"></dxo-row-dragging>
                <dxi-column dataField="title" cellTemplate="brainCellTemplate"></dxi-column>
                <div *dxTemplate="let cellData of 'brainCellTemplate'">
                  <div class="d-flex w-100 h-100 align-items-center justify-content-center">
                    <img src="images/brain.png" alt="Bild" class="bigIcon"/>
                  </div>
                </div>
              </dx-tree-list>
            </div>
          </div>

          <np-catalog-tree #catalogTreeTarget
              [catalogId]="selectedTargetCatalogId"
              [customerId]="selectedCustomerId"
              [catalogList]="targetCatalogs"
              [isTarget]="true"
              [(searchText)]="filterValueTarget"
              selectionMode="single"
              [selectionRecursive]="false"
              [(selectedRowKeys)]="treeSelectedRowKeysTarget"
              [showProductStateOptions]="true"
              [showSearchFormTab]="loginService.hasAddonSearchForm"
              [isTargetFilter]="true"
              [refreshWithSearchForm]="refreshWithSearchForm"
              [syncSearchFormWithService]="false"
              [showContextMenu]="true"
              [menuItems]="menuItems"
              [dragGroup]="'catalogs'"
              [allowDropInsideItem]="true"
              [onDragStartFn]="onDragStartTarget"
              [onDropFn]="onAddTarget"
              (onSelectionChanged)="onSelectionChangedTarget($event)"
              (onRowClick)="onRowClick($event)"
              (onContextMenuShowing)="onContextMenuShowing($event.event, $event.item)"
              (onContextMenuItemClick)="itemClick($event.event, $event.item)"
              (onEditSearchForm)="toggleSearchFormPopup($event)">
          </np-catalog-tree>
        </div>
      </div>
    </div>
  </content-column>
</fullscreen-page>

<np-dialog
    [popupWidth]="1250" [popupHeight]="800" [popupTitle]="'Suchformulare editieren / anlegen' | translate"
    [popupVisible]="searchFormPopupVisible"
    (popupVisibleChange)="onSearchFormPopupVisibleChange($event)">
    <div slot="content">
      <np-search-forms #searchFormsRef
          [initialSearchForm]="initialSearchForm"
      ></np-search-forms>
    </div>
</np-dialog>

<dx-popup [width]="600"
          [height]="750"
          [showTitle]="true"
          title="{{ 'Kategorie Wizard' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="confirmVisible"
          contentTemplate="popupContent">

  <div *dxTemplate="let data of 'popupContent'">

    <div class="dx-fieldset">
      <div class="p-2 flex-fill">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Kosten pro Produkt' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [readOnly]="true"
                           format="#,##0.## €"
                           [value]="invoiceSetting.pricePerCategorAis"></dx-number-box>
          </div>
        </div>
      </div>
      <div class="p-2 flex-fill">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Benutztes Limit' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [readOnly]="true" format="#,##0.## €" [(value)]="invoiceSetting.usedLimit"></dx-number-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Limit' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [readOnly]="true" format="#,##0.## €" [(value)]="invoiceSetting.limit"></dx-number-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Freibetrag' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [readOnly]="true" format="#,##0.## €" [(value)]="invoiceSetting.allowance"></dx-number-box>
          </div>
        </div>
      </div>

      <div class="p-2 flex-fill">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Direkt zuordnen' | translate }}</div>
          <div class="dx-field-value">
            <dx-switch hint="hintMessage" [(value)]="classifaiSetting.directMode"></dx-switch>
          </div>
        </div>
      </div>
      <div class="p-2 flex-fill">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Nur neue Produkte' | translate }}</div>
          <div class="dx-field-value">
            <dx-switch hint="hintMessage" [(value)]="classifaiSetting.onlyNewProducts"></dx-switch>
          </div>
        </div>
      </div>
      <div class="p-2 flex-fill" *ngIf="modelService.loginService.hasAddonDEVELOPMENT">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Leere Merkmale automatisch füllen' | translate }}</div>
          <div class="dx-field-value">
            <dx-switch hint="hintMessage" [(value)]="classifaiSetting.fillEmptyFeatureAutomatically"></dx-switch>
          </div>
        </div>
      </div>
    </div>
    <dx-toolbar>
      <dxi-item location="after"
                widget="dxButton"
                [options]="{
               stylingMode: 'outlined',
               text: ('Starten' | translate),
               width: '100%',
               onClick: startClassifAi
             }">
      </dxi-item>
    </dx-toolbar>
  </div>
</dx-popup>


<dx-popup [width]="600"
          [height]="400"
          [showTitle]="true"
          title="{{ 'Kategorie hinzufügen' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <form (submit)="onAdd()">
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Kategorie' | translate }}</div>
          <div class="dx-field-value">
            <dx-text-box [(value)]="newCategoryName" [showClearButton]="true">
              <dx-validator (onInitialized)="saveValidatorInstance($event)">
                <dxi-validation-rule type="required"
                                     message="{{ 'Bitte geben Sie einen Kategorienamen an' | translate }}!"></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
        <dx-validation-summary id="summary"></dx-validation-summary>
        <div class="dx-field d-flex flex-row">
          <dx-button stylingMode="text"
                     type="default"
                     text="{{ 'Anlegen' | translate }}"
                     [useSubmitBehavior]="true"></dx-button>
        </div>
      </div>
    </form>
  </div>
</dx-popup>
